/*
We can never repeat these keys or else customers won't be shown the modal with new content.
Please add keys to the used list below to make sure we never repeat them in the future:
Previously used keys:
- education-modal-of-table-v2
- education-modal-of-data-quality-score
- education-modal-of-glossary-terms
- education-modal-of-dark-mode
- education-modal-of-secoda-ai-charts
- education-modal-of-secoda-ai-agents
- education-modal-of-secoda-automations
- education-modal-of-secoda-ai-analytics
*/

import type { MantineNumberSize } from '@mantine/core';
import { Text } from '@repo/foundations';
import type { ReactNode } from 'react';

interface EducationModalCopy {
	title: string;
	children: ReactNode;
	imageUrl: string;
	primaryActionUrl: string;
	primaryActionLabel: string;
	learnMoreLink?: string;
	width?: MantineNumberSize;
	expiresAt?: string;
}

export const EDUCATION_MODALS = {
	'education-modal-of-secoda-ai-agents': {
		title: 'Secoda AI Agents are here',
		imageUrl:
			'https://imagedelivery.net/28-eDrK8lEif6_ED0iMQeg/4462d443-a6f2-48cd-1cd3-34a2a8882500/public',
		children: (
			<Text color="text/secondary/default">
				{`Secoda AI now supports Agents which are scheduled tasks to automate repetitive work. Get started by going to the Agents tab in Secoda and build your first agent today.`}
			</Text>
		),
		primaryActionUrl: '/ai/new?tab=agents',
		primaryActionLabel: 'Go to Agents',
		learnMoreLink:
			'https://docs.secoda.com/features/ai-assistant/secoda-ai-agents',
		width: 480,
		expiresAt: '2025-10-01',
	} as EducationModalCopy,
	'education-modal-of-secoda-automations': {
		title: 'AI Automation Block is here',
		imageUrl:
			'https://imagedelivery.net/28-eDrK8lEif6_ED0iMQeg/46dd5e71-c8b5-4ebf-3f19-18b644d88800/public',
		children: (
			<Text color="text/secondary/default">
				{`The new AI Automation Block in Automations lets you generate metadata with optional human review to save you hours. Get started by building your first AI-powered automation today to save hours on documentation, PII tagging, and more at scale.`}
			</Text>
		),
		primaryActionUrl: '/automations',
		primaryActionLabel: 'Go to Automations',
		learnMoreLink:
			'https://docs.secoda.co/features/automations/ai-powered-automations',
		width: 480,
		expiresAt: '2025-10-01',
	} as EducationModalCopy,
	'education-modal-of-secoda-ai-analytics': {
		title: 'AI Analytics just got better',
		imageUrl:
			'https://imagedelivery.net/28-eDrK8lEif6_ED0iMQeg/f0b7f9d7-61ff-4a50-adf6-0d9a77742d00/backgrounds',
		children: (
			<Text color="text/secondary/default">
				{`Explore deeper AI analytics that reveal total time saved, what members are asking, and how Secoda AI is performing — all in one place.`}
			</Text>
		),
		primaryActionUrl: '/analytics/ai-analytics',
		primaryActionLabel: 'View AI Analytics',
		learnMoreLink:
			'https://docs.secoda.co/features/analytics-dashboard#ai-impact-dashboard',
		width: 480,
		expiresAt: '2025-11-11',
	} as EducationModalCopy,
} as const;
